export const environment = {
    production: false,
    api: {
        https: true,
        msSystem: {
            url: 'https://api.system.dev-sonycontent.io/v1',
            systemToken: true
        },
        msLanguageCountry: {
            url: 'https://api.language-country.dev-sonycontent.io/v1',
            systemToken: true
        },
        manager: {
            host: 'manager.dev-sonycontent.io'
        },
        crafter: {
            host: 'crafter.dev-sonycontent.io'
        },
        publisher: {
            host: 'publisher.dev-sonycontent.io'
        },
        adminer: {
            host: 'adminer.dev-sonycontent.io'
        },
        tracker: {
            host: 'tracker.dev-sonycontent.io'
        },
        explorer: {
            host: 'explorer.dev-sonycontent.io'
        },
        clc: {
            host: 'clc.dev-sonycontent.io'
        },
        notifications: {
            host: 'microservices.dev-sonycontent.io'
        },
        resources: {
            cdn: 'cdn01.dev-sonycontent.io'
        },
        msClient: {
            url: 'https://api.client.dev-sonycontent.io/v1',
            systemToken: true
        },
        msUser: {
            url: 'https://api.user.dev-sonycontent.io/v1',
            systemToken: true
        },
        msAuthorization: {
            url: 'https://api.authorization.dev-sonycontent.io/v1',
            systemToken: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts